import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { DataTableContainerComponent } from '../../../../components/data-table-container/data-table-container.component';
import { SignalingFolderBlock } from '../../client-signaling.model';

@Component({
  selector: 'app-signaling-block-folder-table',
  imports: [
    MatIcon,
    MatIconButton,
    MatTableModule,
    MatTooltip,
    DataTableContainerComponent,
  ],
  templateUrl: './signaling-block-folder-table.component.html',
  styleUrl: './signaling-block-folder-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignalingBlockFolderTableComponent {
  dataSource = input<SignalingFolderBlock['data']>([]);

  hideActions = input(false, { transform: booleanAttribute });

  itemRemove = output<string>();

  displayedColumns = ['name', 'actions'];
}
